const styles = (theme) => ({
  container: {
    width: "100%",
    p: 2,
  },
  paper: {
    padding: { xs: "20px", md: "30px" },
    borderRadius: "16px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  containerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  header: { display: "flex", alignItems: "center", gap: 1, mb: 2 },
  title: { fontWeight: "bold", fontSize: "20px" },
  searchInput: {
    display: "flex",
    flexGrow: 1,
    fontSize: "0.90rem",
    maxWidth: "300px",
  },
  noResultsContainer: {
    width: "100%",
    p: 4,
    display: "flex",
    justifyContent: "center",
  },
  noResultsText: {
    color: theme.palette.text.secondary,
  },
  rotasClienteContainer: {
    mt: 3,
  },
});

export default styles;

